define('lib/view_helpers/apps',['require','translate','underscore','lib/view_helpers/base','lib/Podio.Routes'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var viewHelpers = require('lib/view_helpers/base');
  var routes = require('lib/Podio.Routes');

  var exports = {

    app_box_integration_status_text: function(app) {

      var integration = app.get('integration');

      switch(integration.get('status')) {
        case 'inactive':

          if(app.can('update')) {
            return '<a href="{1}">{0}</a>'.format(t('Configure connection to {0} #integration').format(integration.display_name()), routes.edit_app_integration_with_current_space_path(app.get('id'), { format: 'html' }) );
          } else {
            return t('Connection to {0} not configured #integration').format(integration.display_name());
          }
          break;

        case 'error':
          var text = t('Connection to {0} not configured #integration').format(integration.display_name());

          if(app.can('update')) {
            text += ' <a href="{1}">{0}</a>'.format(t('Check settings #integration'), routes.edit_app_integration_with_current_space_path(app.get('id'), { format: 'html' } ) );
          }

          return text;
        case 'active':
          return t('Connected to {0} #integration').format(integration.display_name());
      }
    },

    app_box_integration_last_updated_text: function(integration) {
      if (integration.get('last_updated_on')) {
        return viewHelpers.timestamp(integration.get('last_updated_on'));
      } else {
        return t('Not yet #integration');
      }
    },

    app_box_integration_baloon : function(app) {

      var heading, body;
      var integration = app.get('integration');

      if( integration.get('updating') ) {
        heading =  t('Importing items. #integration');
        body = t('This may take some time depending on how many items you have. Check this page again in a while. #integration');

      } else if( app.can('update') ) {

        if( integration.inactive() ) {
          heading = t('Configure integration. #integration');
          body = t('You need to configure this integration to connect with {0} #integration').format(integration.display_name());
        } else if( integration.error() ) {
          heading = _('Integration ready. #integration');
          body = t('There is a problem with your {0} settings. Click the configuration link to check your settings. #integration').format(integration.display_name());
        } else if( !integration.get('last_updated_on') ) {
          heading = t('Integration ready. #integration');
          body = t('Your integration is ready but has not yet started. Click "Update" to start. #integration');
        }

      }

      if(heading && body) {
        return JSON.stringify({
          'position' : 'left',
          'message' : '<b>' + heading + '</b><br />' + body
        }).htmlEncode();
      } else {
        return '';
      }

    }
  };

  viewHelpers.registerHelpers(exports);

});

